import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { Logo } from "./Header";
import { CATEGORIES, useSettings, waLink } from "../../lib/api";

export const SocialLinks = ({ s, className = "" }) => {
  const items = [
    ["instagram", Instagram], ["facebook", Facebook], ["tiktok", Music2], ["youtube", Youtube],
  ].filter(([k]) => s?.[k]);
  return (
    <div className={`flex gap-3 ${className}`}>
      {items.map(([k, Icon]) => (
        <a key={k} href={s[k]} target="_blank" rel="noreferrer" className="grid h-10 w-10 place-items-center rounded-full border border-current/20 transition-colors hover:bg-[var(--gold)] hover:text-[var(--forest-dark)]" data-testid={`social-${k}`} aria-label={k}>
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};

export const Footer = () => {
  const { data: s } = useSettings();
  return (
    <footer className="bg-[var(--forest-dark)] text-white/80" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-5 max-w-sm text-sm leading-relaxed">Peternakan sapi yang mengutamakan kesehatan ternak, kebersihan kandang, dan pelayanan yang jujur.</p>
          <SocialLinks s={s} className="mt-6 text-white" />
        </div>
        <div>
          <h4 className="mb-4 font-semibold text-[var(--gold)]">Jelajahi</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/katalog" className="hover:text-white">Katalog Sapi</Link></li>
            {CATEGORIES.map((c) => (
              <li key={c.slug}><Link to={`/edukasi?kategori=${c.slug}`} className="hover:text-white">{c.label}</Link></li>
            ))}
            <li><Link to="/kontak" className="hover:text-white">Hubungi Kami</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-semibold text-[var(--gold)]">Kontak</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MessageCircle className="h-4 w-4 shrink-0" /><a href={waLink(s?.whatsapp)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp">+{s?.whatsapp}</a></li>
            <li className="flex gap-2"><Mail className="h-4 w-4 shrink-0" /><a href={`mailto:${s?.email}`} data-testid="footer-email">{s?.email}</a></li>
            <li className="flex gap-2"><MapPin className="h-4 w-4 shrink-0" /><span data-testid="footer-address">{s?.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">© {new Date().getFullYear()} Sembada Satwa. Seluruh hak dilindungi.</div>
    </footer>
  );
};
